import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { ApiError } from 'types/api/ApiError';
import { LoadBuildingSuggestions } from 'types/suggestions/LoadBuildingSuggestions';
import captureException from 'utils/captureException';

type GetLoadBuildingSuggestionOptions = {
  includeHandled?: boolean;
};

// `includeHandled` also returns the thread's built suggestions, with `handledState` and `builtLoad`,
// after the open ones, for Kit's Built group. The response is a plain array either way, and an older
// API that ignores the param returns only open suggestions.
export async function getLoadBuildingSuggestion(
  threadID: string,
  { includeHandled = false }: GetLoadBuildingSuggestionOptions = {}
): Promise<Result<LoadBuildingSuggestions[], ApiError>> {
  try {
    const response = await axios.get<LoadBuildingSuggestions[]>(
      `thread/${encodeURIComponent(threadID)}/suggestions/loadBuilding`,
      includeHandled ? { params: { includeHandled: true } } : undefined
    );
    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'getLoadSuggestion' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to get load building suggestions' });
    }

    return err({
      message:
        error.response?.data.message ||
        'Failed to get load building suggestions',
    });
  }
}
